import React from "react";
import { FaSearch } from "react-icons/fa";
import "../../styles/Header-css/Hedaer/SearchInput.css";

const SearchInput = ({ setSearchTerm }) => {
  return (
    <div className="input-group search-bar">
      <FaSearch className="input-icon" />
      <input
        type="text"
        className="header-input"
        placeholder="Search services..."
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;